<template>
  <div>
    <template v-for="(selectedField,index) in selectedFields">
       <vue-json-layout :model="model" :layout="selectedField.layout" :key="`${index}-${selectedField.propName}`"> </vue-json-layout>
    </template>
    <div v-if="filteredFields.length>0" class="ui form sixteen wide column" >
      <div class="field">
        <select class="ui dropdown" v-model="value">
          <option v-for="(field,index) in filteredFields" :value="field">{{field.label||field.title||field}}</option>
        </select>
      </div>
    </div>

  </div>

</template>

<script>
    export default {
      name: "dynamic-field-control",
      props:{
        fields:Array,
        model:Object,
        selectedFields:Array
      },
      data:()=>{
        return {
          //selectedFields:[],
          value:null
        }
      },
      computed:{
        filteredFields(){
          return this.fields.filter(f=>this.selectedFields.indexOf(f)==-1)
        }
      },
      methods:{

      },
      watch:{
        value(newValue){
          if (newValue) {
            //this.selectedFields.push(newValue);
            this.$emit("input",newValue);
            this.value=null;
          }

        }
      }

    }
</script>

<style scoped>

</style>
